import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SecurityCheckStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M15.4238 7.51956C15.689 7.20152 16.1623 7.15873 16.4805 7.42385C16.7985 7.68906 16.8413 8.16235 16.5762 8.48049L11.5762 14.4805C11.4413 14.6422 11.2445 14.7395 11.0342 14.7491C10.8237 14.7586 10.6187 14.6793 10.4697 14.5303L7.96973 12.0303C7.67683 11.7374 7.67683 11.2626 7.96973 10.9698C8.26262 10.6769 8.73738 10.6769 9.03027 10.9698L10.9492 12.8887L15.4238 7.51956Z"
				fill="currentColor"
			/>
			<path
				d="M20.25 6.12307C20.2499 5.74162 19.9556 5.38615 19.5264 5.31155C16.3594 4.76098 13.7406 3.54024 12.4639 2.86428C12.1761 2.71204 11.8239 2.71204 11.5361 2.86428C10.2594 3.54024 7.64058 4.76098 4.47363 5.31155C4.04445 5.38615 3.7501 5.74163 3.75 6.12307V11.0508C3.75 13.9884 5.23918 16.2898 7.02832 17.9991C8.8199 19.7106 10.8543 20.77 11.7842 21.2012C11.9249 21.2664 12.0751 21.2664 12.2158 21.2012C13.1457 20.77 15.1801 19.7106 16.9717 17.9991C18.7608 16.2898 20.25 13.9884 20.25 11.0508V6.12307ZM21.75 11.0508C21.75 14.5415 19.9702 17.2081 18.0078 19.083C16.048 20.9554 13.8482 22.0971 12.8467 22.5616C12.3058 22.8123 11.6942 22.8123 11.1533 22.5616C10.1518 22.0971 7.95198 20.9554 5.99219 19.083C4.02976 17.2081 2.25 14.5415 2.25 11.0508V6.12307C2.2501 4.95469 3.12738 4.02338 4.2168 3.83401C7.16974 3.32064 9.63203 2.17545 10.834 1.53909C11.561 1.15413 12.439 1.15413 13.166 1.53909C14.368 2.17545 16.8303 3.32065 19.7832 3.83401C20.8727 4.02338 21.7499 4.9547 21.75 6.12307V11.0508Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SecurityCheckStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SecurityCheckStrokeIcon;
